export default __webpack_public_path__ + "static/media/pending-kyc-verification.23763c61.svg";